function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  *, *::before, *::after {\n    box-sizing: border-box;\n  }\n\n  body {\n    margin: 0;\n  }\n\n  .js-focus-visible :focus:not(.focus-visible) {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import 'focus-visible';
import OrangeFont from '../styles/OrangeFont';
import SoshFont from '../styles/SoshFont';
import * as themeOrange from '../themes/orange';
import * as themeSosh from '../themes/sosh';
var ResetCSS = createGlobalStyle(_templateObject());

var OneiProvider = function OneiProvider(_ref) {
  var children = _ref.children,
      theme = _ref.theme,
      includeFont = _ref.includeFont;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme === 'orange' && themeOrange || theme === 'sosh' && themeSosh
  }, /*#__PURE__*/React.createElement(ResetCSS, null), includeFont && theme === 'orange' && /*#__PURE__*/React.createElement(OrangeFont, null), includeFont && theme === 'sosh' && /*#__PURE__*/React.createElement(SoshFont, null), children);
};

OneiProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  theme: PropTypes.oneOf(['orange', 'sosh']).isRequired,
  includeFont: PropTypes.bool
} : {};
OneiProvider.defaultProps = {
  includeFont: false
};
export default OneiProvider;